import { useNavigate } from "react-router-dom";

const SubadminDetail = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Sub-Admin Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</button>
          {' '} - Sub-Admin Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src="/static/images/user_placeholder.png" />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>David</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>davidexample.com</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>9876543210</p>
          </div>
          <div className="w_33">
            <h6>Role</h6>
            <p>Role 1</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>01 March 2025</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubadminDetail;
